<h5 [ngClass]="[fontWeight, fontColor, cursorType, textDecoration, textLine]">
  <ng-content></ng-content>
</h5>
